import { LegalContext } from '~/machines/legal-completion';
import { SolarFunnelContext, solarMachine } from '~/machines/solar-funnel';
import { UploadContext } from '~/machines/upload';
import { UserContext } from '~/machines/user-creation';
import { getInitialState } from '~/utils/funnels';
import { config } from './config';

export const funnelMachine = () =>
  solarMachine({
    id: config.id,
    initialState: getInitialState(config.id, solarMachine),
    user: {
      context: { requirePhone: true, showInviteCode: true },
    },
  }).withConfig({
    guards: {
      isPowerSetter: context => isPowerSetter(context),
    },
  });

export const isPowerSetter = (
  context: SolarFunnelContext | LegalContext | UploadContext | UserContext,
) => context?.funnelId === config.id;
